import { BasePathProvider } from "components/Providers"
import PunchRecordsListIndex from "./List"
import { Drawer } from "@mui/material"
import PunchRecordsFormIndex from "./Form"
import { useNavigate, useParams } from "react-router-dom"

export default function PunchRecordsPage() {
    const basePath = `/leave-request/punch-records`
    const { punchRecordId } = useParams()
    const navigate = useNavigate()

    return (
        <BasePathProvider value={`${basePath}`}>
            <PunchRecordsListIndex />
            <Drawer
                PaperProps={{
                    sx: {
                        width: 800,
                    },
                }}
                open={Boolean(punchRecordId)}
                anchor="right"
                onClose={() => navigate(`${basePath}`)}
            >
                <PunchRecordsFormIndex />
            </Drawer>
        </BasePathProvider>
    )
}
